import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";

import Typography from "@insite/mobius/Typography";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import ProductListFiltersAccordionSection, {
    ProductListFilterAccordionSectionStyles,
} from "./ProductListFilterAccordionSection";
import { css } from "styled-components";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getProp } from "@insite/mobius/utilities";
import { CategoryDetailsPageContext } from "@NA/Overrides/Pages/CategoryDetailsPage";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const currentPathname = getLocation(state).pathname;
    return {
        session: state.context.session,
        attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
        location: getLocation(state),
        showMobileFilter: state.ADIGlobalData.ADIMobileFilterStore.showMobileFilters,
        myBranchDetails: state.ADIGlobalData.myBranchStore,
        isDealsPage: currentPathname.toLowerCase().includes("catalog/deals"),
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

const MORE_WAYS_TO_SAVE = "More Ways To Save";

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListAttributeFiltersStyles: ProductListFilterAccordionSectionStyles = {
    filterText: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 800;
        `,
    },
};
const styles = productListAttributeFiltersStyles;
const updateUrl = (newAttributes: string[], boostid: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set('attributes', newAttributes.join(',')); 
    if (boostid) {
        url.searchParams.set('boostids', boostid);
    }
    window.history.pushState({}, '', url.toString());
    window.location.reload();
};
const ProductListAttributeFilters: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    removeProductFilters,
    fields,
    location,
    showMobileFilter,
    myBranchDetails,
    isDealsPage,
    session,
}) => {
    // TODO ISC-11787 - make showMoreLimit configurable
    // const showMoreLimit = 10; //previous showMoreLimit value
    const showMoreLimit = 6;

    if (!attributeTypeFacets?.length) {
        return null;
    }

    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    const moreWaysToSave = attributeTypeFacets.filter(
        section =>
            section.name !== "Availability" &&
            section.name !== "More Ways To Save" &&
            section.name !== "More Ways to Save" &&
            section.name !== "Brand Name" &&
            section.name !== "Category" &&
            section.name !== "Sub Category" &&
            section.name !== "Category Type",
    );

    const primaryFacetList = attributeTypeFacets.filter(
        a => a.attributeValueFacets && !moreWaysToSave?.some(item => item.name === a.name),
    );

    const customOrder = [
        "Availability",
        "Brand Name",
        "Category",
        "Sub Category",
        "Category Type",
        "More Ways to Save",
    ];

    const primaryFacets = [...primaryFacetList].sort((a, b) => {
        const indexA = customOrder.indexOf(a.name);
        const indexB = customOrder.indexOf(b.name);
        return indexA - indexB;
    });

    const onChangeFacet = (facet: FacetModel, title?: string) => {
        const currentAttributes = new URLSearchParams(location.search).get('attributes')?.split(',') || [];
        const boostid = new URLSearchParams(location.search).get('boostids') || '';
    
        if (boostid) {
            const urlWithoutBoostId = new URL(window.location.href);
            urlWithoutBoostId.searchParams.delete('boostids');
            window.history.pushState({}, '', urlWithoutBoostId.toString());
        if (facet.selected) {
            removeProductFilters({ attributes: [facet.id] });
            const updatedAttributes = currentAttributes.filter(attr => attr !== facet.id);
            updateUrl(updatedAttributes, boostid);
        } else {
            addProductFilters({ attributes: [facet.id] });
            const updatedAttributes = [...currentAttributes, facet.id];
            updateUrl(updatedAttributes, boostid);
            }
            const finalUrl = new URL(window.location.href);
            finalUrl.searchParams.set('boostids', boostid);
            window.history.pushState({}, '', finalUrl.toString());
        } else {
            if (facet.selected) {
                removeProductFilters({ attributes: [facet.id] });
            } else {
                addProductFilters({ attributes: [facet.id] });
            }
        }
    };

    return (
        <>
            {isDealsPage &&
                primaryFacets.map(a =>
                    a.attributeValueFacets ? (
                        <>
                            {a.name.toLowerCase() !== MORE_WAYS_TO_SAVE.toLowerCase() && (
                                <ProductListFiltersAccordionSection
                                    key={a.attributeTypeId}
                                    title={a.nameDisplay}
                                    facets={a.attributeValueFacets.map<FacetModel>(av => ({
                                        ...av,
                                        id: av.attributeValueId,
                                        name: av.valueDisplay,
                                    }))}
                                    onChangeFacet={onChangeFacet}
                                    showMoreLimit={showMoreLimit}
                                    expandByDefault={!showMobileFilter ? true : false}
                                    extendedStyles={productListCategoryFiltersStyles}
                                    myBranchDetails={myBranchDetails}
                                    isAuthenticated={isAuthenticated}
                                />
                            )}
                        </>
                    ) : null,
                )}
            {!isDealsPage &&
                primaryFacets.map(a =>
                    a.attributeValueFacets ? (
                        <ProductListFiltersAccordionSection
                            key={a.attributeTypeId}
                            title={a.nameDisplay}
                            facets={a.attributeValueFacets.map<FacetModel>(av => ({
                                ...av,
                                id: av.attributeValueId,
                                name: av.valueDisplay,
                            }))}
                            onChangeFacet={onChangeFacet}
                            showMoreLimit={showMoreLimit}
                            expandByDefault={!showMobileFilter ? true : false}
                            extendedStyles={productListCategoryFiltersStyles}
                            myBranchDetails={myBranchDetails}
                            isAuthenticated={isAuthenticated}
                        />
                    ) : null,
                )}
            {moreWaysToSave && moreWaysToSave?.length && !showMobileFilter ? (
                <Typography {...styles.filterText} data-test-selector="productListFilterList">
                    {translate("More Ways to Shop")}
                </Typography>
            ) : null}

            {moreWaysToSave?.length
                ? moreWaysToSave?.map(a =>
                      a.attributeValueFacets ? (
                          <ProductListFiltersAccordionSection
                              key={a.attributeTypeId}
                              title={a.nameDisplay}
                              facets={a.attributeValueFacets.map<FacetModel>(av => ({
                                  ...av,
                                  id: av.attributeValueId,
                                  name: av.valueDisplay,
                              }))}
                              onChangeFacet={onChangeFacet}
                              showMoreLimit={showMoreLimit}
                              expandByDefault={fields.expandByDefault}
                              extendedStyles={productListCategoryFiltersStyles}
                              myBranchDetails={myBranchDetails}
                              isAuthenticated={isAuthenticated}
                          />
                      ) : null,
                  )
                : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListAttributeFilters),
    definition: {
        group: "Product List",
        displayName: "Attribute Filters",
        allowedContexts: [ProductListPageContext, CategoryDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
